import { render, staticRenderFns } from "./Matricula2021.vue?vue&type=template&id=f7f4d2d6&"
import script from "./Matricula2021.vue?vue&type=script&lang=js&"
export * from "./Matricula2021.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports